var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-grey-lightest" },
    [
      _c(
        "section",
        { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
        [_c("header-nav")],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "py-12" }, [
        _c("div", { staticClass: "max-w-sm mx-auto px-6" }, [
          _vm.errorText
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "rounded bg-white shadow relative -mt-24" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                        attrs: { to: { path: "/" } }
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", { staticClass: "mdi mdi-close" })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "text-sm text-xl ml-4",
                          domProps: {
                            textContent: _vm._s(
                              _vm.errorText
                                ? _vm.errorText
                                : _vm.$t("an_error_occured")
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ])
            : _c("div", [
                _vm.appointment
                  ? _c(
                      "div",
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "rounded bg-white shadow relative -mt-24"
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2",
                                attrs: { to: { path: "/" } }
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", { staticClass: "mdi mdi-close" })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "p-6 bg-teal text-white rounded-t"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Appointment_confirmed"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-4 text-sm" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "The_practitioner_is_allowed_to_ask_for_a_compensation_if_you_dont_show_up_at_the_appointment_"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "p-4 md:p-6" }, [
                              _c("div", { staticClass: "mb-4" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-blue font-semibold text-sm mb-1"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("When_")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-black font-semibold text-lg"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("momentFormat")(
                                          _vm.appointment.date,
                                          "YYYY-MM-DD",
                                          _vm.$t("date_selector_format")
                                        )
                                      ) +
                                        " " +
                                        _vm._s(_vm.$t("at")) +
                                        " " +
                                        _vm._s(
                                          _vm._f("momentFormatTime")(
                                            _vm.appointment.time,
                                            _vm.$t("time_format")
                                          )
                                        )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-4 flex justify-between" },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-blue font-semibold text-sm mb-1"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Who_will_treat_me_"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-grey-darkest" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.appointment.doctorFirstName +
                                              " " +
                                              _vm.appointment.doctorLastName
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.appointment.isDoctorRegulated &&
                                    (_vm.appointment.emergencyType !==
                                      "OSTEOPATH" &&
                                      _vm.appointment.emergencyType !==
                                        "PSYCHOLOGIST")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-green font-semibold text-sm mt-1 mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "€ " +
                                                _vm._s(
                                                  _vm.$t("Contracted_doctor")
                                                )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.appointment.isDoctorRegulated &&
                                    (_vm.appointment.emergencyType !==
                                      "OSTEOPATH" &&
                                      _vm.appointment.emergencyType !==
                                        "PSYCHOLOGIST")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-red font-semibold text-sm mt-1 mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "€ " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Contracted_doctor_negative"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "flex md:hidden items-center text-blue outline-0 uppercase tracking-wide",
                                        attrs: {
                                          href:
                                            "tel:" + _vm.appointment.officePhone
                                        }
                                      },
                                      [
                                        _vm._m(1),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-2 text-xs font-semibold"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("Call")))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "hidden md:inline-flex items-center text-blue outline-0 uppercase tracking-wide",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.showOfficePhone($event)
                                          }
                                        }
                                      },
                                      [
                                        _vm._m(2),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-2 text-xs font-semibold"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("Call")))]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("avatar", {
                                        staticClass: "w-10 h-10",
                                        attrs: {
                                          avatar: _vm.appointment.doctorAvatar,
                                          name:
                                            _vm.appointment.doctorFirstName +
                                            " " +
                                            _vm.appointment.doctorLastName
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-blue font-semibold text-sm mb-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Where_have_I_to_go_"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-grey-darkest mb-2" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.appointment.officeZipCode) +
                                        " " +
                                        _vm._s(_vm.appointment.officeLocality) +
                                        "\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.appointment.officeStreetNumber
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.appointment.officeStreetName
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "flex md:hidden items-center text-blue outline-0 uppercase tracking-wide",
                                    attrs: {
                                      href:
                                        "https://www.google.com/maps/dir/?api=1&destination=" +
                                        _vm.appointment.officeStreetNumber +
                                        " " +
                                        _vm.appointment.officeStreetName +
                                        ", " +
                                        _vm.appointment.officeZipCode +
                                        " " +
                                        _vm.appointment.officeLocality,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-2 text-xs font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Itinerary")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "hidden md:inline-flex items-center text-blue outline-0 uppercase tracking-wide",
                                    attrs: {
                                      href:
                                        "https://www.google.com/maps/dir/?api=1&destination=" +
                                        _vm.appointment.officeStreetNumber +
                                        " " +
                                        _vm.appointment.officeStreetName +
                                        ", " +
                                        _vm.appointment.officeZipCode +
                                        " " +
                                        _vm.appointment.officeLocality,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-2 text-xs font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Itinerary")))]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "gmap-map",
                              {
                                staticClass: "w-full",
                                staticStyle: { height: "250px" },
                                attrs: {
                                  center: {
                                    lat: _vm.appointment.officeLocation._lat,
                                    lng: _vm.appointment.officeLocation._long
                                  },
                                  zoom: 12,
                                  options: { disableDefaultUI: true }
                                }
                              },
                              [
                                _c("gmap-marker", {
                                  attrs: {
                                    position: {
                                      lat: _vm.appointment.officeLocation._lat,
                                      lng: _vm.appointment.officeLocation._long
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center mt-3" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "text-xs hover:underline text-grey font-semibold uppercase tracking-wide px-1 py-1",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.showCancel($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Cancel_the_appointment")))]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.appointment
                          ? _c("dfp-slot", {
                              staticClass: "mt-6",
                              attrs: {
                                path: "/21865209613/Patients/AppointmentShow",
                                size: [300, 250],
                                id: "div-gpt-ad-partner-appointment",
                                "medical-practice":
                                  _vm.appointment.emergencyType
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _c("div", [_c("patient-loading")], 1)
              ])
        ])
      ]),
      _vm._v(" "),
      _c("cancel-appointment-modal", {
        attrs: { active: _vm.showCancelModal, appointment: _vm.appointment },
        on: { close: _vm.hideCancel }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-directions" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-directions" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7866fddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7866fddc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/AppointmentShow.vue
// module id = 777
// module chunks = 1